import { useEffect } from 'react';

export function useProximityOffset(wrapRef, x, y, setIsNear, radius) {
  useEffect(() => {
    if (window.matchMedia('(pointer: coarse)').matches) return undefined;

    const handleMove = (e) => {
      const el = wrapRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);

      if (dist < radius) {
        const strength = 1 - dist / radius;
        const angle = Math.atan2(dy, dx);
        const offset = strength * 16;
        x.set(-Math.cos(angle) * offset);
        y.set(-Math.sin(angle) * offset);
        setIsNear(true);
      } else {
        x.set(0);
        y.set(0);
        setIsNear(false);
      }
    };

    window.addEventListener('mousemove', handleMove);
    return () => window.removeEventListener('mousemove', handleMove);
  }, [wrapRef, x, y, setIsNear, radius]);
}
